import React from "react";
import { SymbolComponentType } from "../helpers/getSymbol";

const AircraftSymbol = (props: SymbolComponentType) => {
  const { index, attributes, transformStr } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14.94 12.66"
      key={index}
      id={`symbol-${index}`}
      tabIndex={0}
      className="symbol target"
      name="symbol"
      preserveAspectRatio="xMidYMid meet"
      style={{
        top: `${attributes.top}%`,
        left: `${attributes.left}%`,
        width: `${attributes.width}%`,
        height: `${attributes.height}%`,
        zIndex: attributes.zIndex,
        // transform:`rotate(${attributes?.transform?.rotate}deg) scaleX(${attributes?.transform?.scaleX}) scaleY(${attributes?.transform?.scaleY}) matrix3d(${attributes?.transform?.matrix3d})`
        transform: transformStr,
      }}
    >
      <path
        stroke={`${attributes.borderColor || "white"}`}
        fill={`${attributes?.backgroundColor || "white"}`}
        strokeWidth={`${attributes.lineWidth || 0.1}`}
        // className="aircraft_symbol"
        d="M 6.3,0 H 5.42 V 5.78 H 0 v 0.87 h 5.42 v 5.26 H 3.24 v 0.75 H 5.42 6.3 V 11.91 6.65 5.78 0 Z"
      />
      <path
        stroke={`${attributes.borderColor || "white"}`}
        fill={`${attributes?.backgroundColor || "white"}`}
        strokeWidth={`${attributes.lineWidth || 0.1}`}
        // className="aircraft_symbol"
        d="M 9.52,0 H 8.65 v 5.78 0.87 5.26 0.75 H 9.52 11.7 V 11.91 H 9.52 V 6.65 h 5.42 V 5.78 H 9.52 V 0 Z"
      />
    </svg>
  );
};

export default AircraftSymbol;
